// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"0d51a0b1","303":"69d954e7","311":"1a1c3afe","680":"02a1ee2b","692":"84c6bbb4","924":"cd8a57a9"}[chunkId] + ".chunk.css";
};